import type { Table } from "dexie";
import { BaseDexieRepository } from "./base-repository";
import type { AudioRecordingCapturedAudioRecord } from "@/domains/dexie-db/models/audio-recording-legacy";

export class AudioRecordingLegacyCapturedAudioRepository extends BaseDexieRepository<AudioRecordingCapturedAudioRecord> {
  constructor(table: Table<AudioRecordingCapturedAudioRecord, number>) {
    super({ tableRef: () => table });
  }

  async save(record: AudioRecordingCapturedAudioRecord): Promise<void> {
    await this.transaction("rw", async () => {
      if (record.noteId) {
        await this.table.where({ noteId: record.noteId }).delete();
      }
      await this.table.where({ recordingId: record.recordingId }).delete();
      await this.table.add(record);
    });
  }

  async getByRecordingId(
    recordingId: string
  ): Promise<AudioRecordingCapturedAudioRecord | undefined> {
    return this.table.where({ recordingId }).first();
  }

  async getLatestByNoteId(noteId: string): Promise<AudioRecordingCapturedAudioRecord | undefined> {
    const records = await this.table.where({ noteId }).toArray();
    return records.sort((a, b) => (b.createdAt ?? 0) - (a.createdAt ?? 0))[0];
  }

  async clearByNoteId(noteId: string): Promise<void> {
    await this.table.where({ noteId }).delete();
  }

  async deleteByRecordingId(recordingId: string): Promise<void> {
    await this.table.where({ recordingId }).delete();
  }

  async getLatest(): Promise<AudioRecordingCapturedAudioRecord | undefined> {
    const records = await this.table.orderBy("createdAt").toArray();
    return records.at(-1);
  }
}
